import { usePostUpdateReleaseNotes } from 'hooks/usePostUpdateReleaseNotes';
import { PostUpdateReleaseNotesDialog } from 'components/releaseNotes/PostUpdateReleaseNotesDialog';

export function PostUpdateContainer() {
  const { isOpen, releaseNoteToShow, acknowledgeUpdate } = usePostUpdateReleaseNotes();
  return (
    <PostUpdateReleaseNotesDialog
      isOpen={isOpen}
      releaseNote={releaseNoteToShow}
      onClose={acknowledgeUpdate}
    />
  );
}
